import { render, staticRenderFns } from "./movimientosSaldo.vue?vue&type=template&id=389b1bbe&scoped=true"
import script from "./movimientosSaldo.vue?vue&type=script&lang=js"
export * from "./movimientosSaldo.vue?vue&type=script&lang=js"
import style0 from "./movimientosSaldo.vue?vue&type=style&index=0&id=389b1bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b1bbe",
  null
  
)

export default component.exports